import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: "/",
      meta: {
        // breadcrumb: '',
        showFather: true,
      },
      component: (resolve) => {
        require(["../components/Home"], resolve);
      },
      children: [
        {
          path: "/goto",
          name: "Goto",
          component: (resolve) => {
            require(["../components/Goto"], resolve);
          },
        },
        {
          path: "/help",
          name: "Help",
          component: (resolve) => {
            require(["../components/Help"], resolve);
          },
        },
        {
          path: "/recruitment",
          name: "Recruitment",
          meta: {
            breadcrumb: "诚聘英才",
          },
          component: (resolve) => {
            require(["../components/Recruitment"], resolve);
          },
        },
        {
          path: "/Contact",
          name: "Contact",
          meta: {
            breadcrumb: "联系我们",
          },
          component: (resolve) => {
            require(["../components/Contact"], resolve);
          },
        },
        {
          path: "/about",
          name: "About",
          meta: {
            breadcrumb: "关于我们",
          },
          component: (resolve) => {
            require(["../components/About"], resolve);
          },
        },
        {
          path: "/anli_engineering",
          name: "Anli_Engineering",
          meta: {
            breadcrumb: "智能工程案例",
          },
          component: (resolve) => {
            require(["../components/Anli_Engineering"], resolve);
          },
        },
        {
          path: "/service",
          name: "Service",
          meta: {
            breadcrumb: "品牌服务",
          },
          component: (resolve) => {
            require(["../components/Service"], resolve);
          },
        },
        {
          path: "/anli",
          name: "Anli",
          meta: {
            breadcrumb: "智能仪表案例",
          },
          component: (resolve) => {
            require(["../components/Anli"], resolve);
          },
        },
        {
          path: "partner/",
          name: "Partner",
          meta: {
            breadcrumb: "合作伙伴",
            showFather: false,
          },
          component: (resolve) => {
            require(["../components/Partner"], resolve);
          },
          children: [
            {
              path: "partnerInfo/:id",
              name: "PartnerInfo",
              meta: {
                breadcrumb: "合作伙伴",
                showSec: false,
              },
              component: (resolve) => {
                require(["../components/PartnerInfo"], resolve);
              },
            },
          ],
        },
        {
          path: "/engineering",
          name: "Engineering",
          meta: {
            breadcrumb: "智能工程",
          },
          component: (resolve) => {
            require(["../components/Engineering"], resolve);
          },
          children: [
            {
              path: "engineeringInfo/:id",
              name: "EngineeringInfo",
              meta: {
                breadcrumb: "工程信息",
                showSec: false,
              },
              component: (resolve) => {
                require(["../components/engineeringInfo"], resolve);
              },
            }
          ]
        },
        {
          path: "/intelligentDevice",
          name: "IntelligentDevice",
          meta: {
            breadcrumb: "智能设备",
          },
          component: (resolve) => {
            require(["../components/IntelligentDevice"], resolve);
          },
          children: [
            {
              path: "intelligentDeviceInfo",
              name: "IntelligentDeviceInfo",
              meta: {
                breadcrumb: "设备信息",
                showSec: false,
              },
              component: (resolve) => {
                require(["../components/IntelligentDeviceInfo"], resolve);
              },
            }
          ]
        },
        {
          path: "/EmployeeStyle",
          name: "EmployeeStyle",
          meta: {
            breadcrumb: "员工风采",
          },
          component: (resolve) => {
            require(["../components/EmployeeStyle"], resolve);
          },
        },
        {
          path: "news",
          name: "News",
          meta: {
            breadcrumb: "新闻资讯",
            showFather: false,
          },
          component: (resolve) => {
            require(["../components/News"], resolve);
          },
          children: [
            {
              path: "newsdel/:id",
              name: "Newsdel",
              meta: {
                breadcrumb: "资讯详情",
                showSec: false,
              },
              component: (resolve) => {
                require(["../components/Newsdel"], resolve);
              },
            },
          ],
        },
        {
          path: "product",
          name: "Product",
          meta: {
            breadcrumb: "产品中心",
            showFather: false,
          },
          component: (resolve) => {
            require(["../components/Product"], resolve);
          },
          children: [
            {
              path: "device/:id",
              name: "Device",
              meta: {
                breadcrumb: "设备信息",
                showSec: false,
              },
              component: (resolve) => {
                require(["../components/Device"], resolve);
              },
            },
          ],
        },
        {
          path: "instrument",
          name: "Instrument",
          meta: {
            breadcrumb: "智能仪表",
            showFather: false,
          },
          component: (resolve) => {
            require(["../components/Instrument"], resolve);
          },
        },
      ],
    },
    // {
    //     path: '/news',
    //     name: 'News',
    //     meta: {
    //         breadcrumb: '新闻资讯',
    //     },
    //     component: (resolve) => {
    //         require(['../components/News'], resolve)
    //     }
    // },
    // {
    //     path: '/newsdel/:id',
    //     name: 'Newsdel',
    //     meta: {
    //         breadcrumb: '资讯详情',
    //     },
    //     component: (resolve) => {
    //         require(['../components/Newsdel'], resolve)
    //     }
    // },
    // {
    //     path: '/EmployeeStyle',
    //     name: 'EmployeeStyle',
    //     meta: {
    //         breadcrumb: '员工风采',
    //     },
    //     component: (resolve) => {
    //         require(['../components/EmployeeStyle'], resolve)
    //     }
    // },
    // {
    //     path: '/product',
    //     name: 'Product',
    //     meta: {
    //         breadcrumb: '智能仪表',
    //         // showFather: true,
    //     },
    //     component: (resolve) => {
    //         require(['../components/Product'], resolve)
    //     },
    //     children: [{
    //         path: 'device/:id',
    //         name: 'DeviceDetail',
    //         meta: {
    //             breadcrumb: '设备信息',
    //             // showFather: false,
    //         },
    //         component: (resolve) => {
    //             require(['../components/Device'], resolve)
    //         }
    //     }]
    // },
    // {
    //     path: '/device/:id',
    //     name: 'Device',
    //     meta: {
    //         breadcrumb: '设备信息',
    //     },
    //     component: (resolve) => {
    //         require(['../components/Device'], resolve)
    //     }
    // },
    // {
    //     path: '/engineering',
    //     name: 'Engineering',
    //     meta: {
    //         breadcrumb: '智能工程',
    //     },
    //     component: (resolve) => {
    //         require(['../components/Engineering'], resolve)
    //     },
    // },
    // {
    //     path: '/intelligentDevice',
    //     name: 'IntelligentDevice',
    //     meta: {
    //         breadcrumb: '智能设备',
    //     },
    //     component: (resolve) => {
    //         require(['../components/IntelligentDevice'], resolve)
    //     },
    // },
    // {
    //     path: '/partner/',
    //     name: 'Partner',
    //     meta: {
    //         breadcrumb: '合作伙伴',
    //     },
    //     component: (resolve) => {
    //         require(['../components/Partner'], resolve)
    //     }
    // },
    // {
    //     path: '/partnerInfo/:id',
    //     name: 'PartnerInfo',
    //     meta: {
    //         breadcrumb: '合作伙伴',
    //     },
    //     component: (resolve) => {
    //         require(['../components/PartnerInfo'], resolve)
    //     }
    // },
    // {
    //     path: '/service',
    //     name: 'Service',
    //     meta: {
    //         breadcrumb: '品牌服务',
    //     },
    //     component: (resolve) => {
    //         require(['../components/Service'], resolve)
    //     }
    // },
    // {
    //     path: '/anli',
    //     name: 'Anli',
    //     meta: {
    //         breadcrumb: '智能仪表案例',
    //     },
    //     component: (resolve) => {
    //         require(['../components/Anli'], resolve)
    //     }
    // },
    // {
    //     path: '/anli_engineering',
    //     name: 'Anli_Engineering',
    //     meta: {
    //         breadcrumb: '智能工程案例',
    //     },
    //     component: (resolve) => {
    //         require(['../components/Anli_Engineering'], resolve)
    //     }
    // },
    // { //案例三级页面（暂无）
    //     path: '/anlidel/:id',
    //     name: 'Anlidel',
    //     component: (resolve) => {
    //         require(['../components/Anlidel'], resolve)
    //     }
    // },
    // {
    //     path: '/goto',
    //     name: 'Goto',
    //     component: (resolve) => {
    //         require(['../components/Goto'], resolve)
    //     }
    // },
    // {
    //     path: '/help',
    //     name: 'Help',
    //     component: (resolve) => {
    //         require(['../components/Help'], resolve)
    //     }
    // },
    // {
    //     path: '/recruitment',
    //     name: 'Recruitment',
    //     meta: {
    //         breadcrumb: '诚聘英才',
    //     },
    //     component: (resolve) => {
    //         require(['../components/Recruitment'], resolve)
    //     }
    // },
    // {
    //     path: '/Contact',
    //     name: 'Contact',
    //     meta: {
    //         breadcrumb: '联系我们',
    //     },
    //     component: (resolve) => {
    //         require(['../components/Contact'], resolve)
    //     }
    // },
    // {
    //     path: '/about',
    //     name: 'About',
    //     meta: {
    //         breadcrumb: '关于我们',
    //     },
    //     component: (resolve) => {
    //         require(['../components/About'], resolve)
    //     }
    // },
    {
      path: "/study",
      name: "Study",
      component: (resolve) => {
        require(["../components/Study"], resolve);
      },
    },
    {
      path: "/login",
      name: "Login",
      component: (resolve) => {
        require(["../components/Login"], resolve);
      },
    },
    {
      path: "/appDownload",
      name: "appDownload",
      component: (resolve) => {
        require(["../components/AppDownload"], resolve);
      },
    },
    {
      path: "/admin",
      name: "Admin",
      // 需要登录才能进入的页面可以增加一个meta属性
      meta: {
        requireAuth: true,
      },
      component: (resolve) => {
        require(["../components/Admin"], resolve);
      },
      children: [
        {
          path: "/admin/user",
          name: "User",
          component: (resolve) => {
            require(["../components/admin/User"], resolve);
          },
        },
        {
          path: "/admin/news",
          name: "AdminNews",
          component: (resolve) => {
            require(["../components/admin/News"], resolve);
          },
        },
        {
          path: "/admin/recruitment",
          name: "AdminRecruitment",
          component: (resolve) => {
            require(["../components/admin/Recruitment"], resolve);
          },
        },
        {
          path: "/admin/messages",
          name: "Messages",
          component: (resolve) => {
            require(["../components/admin/Messages"], resolve);
          },
        },
        {
          path: "/admin/demand",
          name: "Demand",
          component: (resolve) => {
            require(["../components/admin/Demand"], resolve);
          },
        },
        {
          path: "/admin/cases",
          name: "Cases",
          component: (resolve) => {
            require(["../components/admin/Cases"], resolve);
          },
        },
        {
          path: "/admin/team",
          name: "Team",
          component: (resolve) => {
            require(["../components/admin/Team"], resolve);
          },
        },
        {
          path: "/admin/course",
          name: "Course",
          component: (resolve) => {
            require(["../components/admin/Course"], resolve);
          },
        },
        {
          path: "/admin/dictionary",
          name: "Dictionary",
          component: (resolve) => {
            require(["../components/admin/DataDictionary"], resolve);
          },
        },
        {
          path: "/admin/honor",
          name: "Honor",
          component: (resolve) => {
            require(["../components/admin/Honor"], resolve);
          },
        },
        {
          path: "/admin/study",
          name: "AdminStudy",
          component: (resolve) => {
            require(["../components/admin/Study"], resolve);
          },
        },
        {
          path: "/admin/enterprise",
          name: "Adminenterprise",
          component: (resolve) => {
            require(["../components/admin/Enterprise"], resolve);
          },
        },
      ],
    },
  ],
});

//  判断是否需要登录权限 以及是否登录
router.beforeEach((to, from, next) => {
  if (to.matched.some((res) => res.meta.requireAuth)) {
    // 判断是否需要登录权限
    //console.log(localStorage.getItem("loginName"))
    //if (sessionStorage.getItem('Ticket'))
    if (localStorage.getItem("loginName")) {
      // 判断是否登录
      next();
    } else {
      // 没登录则跳转到登录界面
      next({
        path: "/login",
        query: {
          redirect: to.fullPath,
        },
      });
    }
  } else {
    next();
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/router.js